import { colors } from '@globals/themes/defaultTheme'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import Chip from '@mui/material/Chip'
import Typography from '@mui/material/Typography'
import { SxProps } from '@mui/material/styles'
import { ReactElement } from 'react'
import { AutoCompleteRenderChipProps } from './StandardAutoCompleteSearch'

export const autoCompleteChipStyle: SxProps = {
  backgroundColor: colors.grayUltraLight,
  borderColor: 'transparent',
  m: 0.25,
  '&.MuiChip-root': {
    minHeight: 32,
  },
}

const chipLabelStyles: SxProps = {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
}

export type AutoCompleteChipProps = AutoCompleteRenderChipProps & {
  label: string
  labelStyles?: SxProps
  avatar?: ReactElement
  chipStyle?: SxProps
  icon?: ReactElement
}

const AutoCompleteChip: React.FC<AutoCompleteChipProps> = ({
  label,
  labelStyles = chipLabelStyles,
  avatar,
  chipStyle,
  icon,
  disabled,
  onDelete,
  ...otherProps
}) => {
  return (
    <Chip
      variant="outlined"
      size="small"
      avatar={avatar}
      label={
        <Typography variant="body1" sx={labelStyles}>
          {label}
        </Typography>
      }
      sx={{ ...autoCompleteChipStyle, ...chipStyle }}
      onDelete={!disabled ? onDelete : undefined}
      deleteIcon={<CloseOutlinedIcon />}
      icon={icon}
      disabled={disabled}
      {...otherProps}
    />
  )
}

export default AutoCompleteChip
